//@ts-nocheck
import * as React from 'react';
import MapContainer from "../../Common/MapContainer";
import { getStateAbbr } from '../../Common/Helpers';
import { exportFactSheetChart } from './FactSheetButtonHelpers';

class CongressionalDistrictMaps extends React.Component<Props, {}> {

    render() {
        const { university, start_year, current_year, congress_map, congress_map_range, usStateList, state_fips, statename } = this.props;

        if (congress_map && congress_map_range && usStateList && state_fips)
            
            return (
                <>
                    <div className="row congressmap-row">
                        <div className="col-md-12">
                            <div className="congressmap_div">
                                <a className="factsheet-map-export" onClick={() => exportFactSheetChart("congressmap_div", 0, `congressional-district-map-fy-${current_year}.png`)}>
                                    <i className="fa fas fa-download ecr_export"></i>EXPORT CHART
                                </a>
                                <h4 style={{ textAlign: "center" }}>{university}<br />Research-Related Spending (Federal),<br />by Congressional District ({getStateAbbr(statename)}), FY {current_year}</h4>
                                <MapContainer
                                    factSheet={true}
                                    isInState={true}
                                    isZoomed={false}
                                    isCongress={true}
                                    state_fips={state_fips}
                                    mapData={congress_map}
                                    USState={usStateList}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row congressmap-row">
                        <div className="col-md-12">
                            <div className="congressmap_div">
                                <a className="factsheet-map-export" onClick={() => exportFactSheetChart("congressmap_div", 1, `congressional-district-map-fy-${start_year}-${current_year}.png`)}>
                                    <i className="fa fas fa-download ecr_export"></i>EXPORT CHART
                                </a>
                                <h4 style={{ textAlign: "center" }}>{university}<br />Research-Related Spending (Federal),<br />by Congressional District ({getStateAbbr(statename)}), FY {start_year}-{current_year}</h4>
                                <MapContainer
                                    factSheet={true}
                                    isInState={true}
                                    isZoomed={false}
                                    isCongress={true}
                                    state_fips={state_fips}
                                    mapData={congress_map_range}
                                    USState={usStateList}
                                />
                            </div>
                        </div>
                    </div>
                </>
            );
        else return (<div></div>)
    }
}

export default CongressionalDistrictMaps;